/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CitaModelDto } from '../../models/cita-model-dto';

export interface CitasControllerObtencionCitas$Params {

/**
 * Límite de licitaciones por página
 */
  limit?: number;

/**
 * Número de página para paginación
 */
  page?: number;
}

export function citasControllerObtencionCitas(http: HttpClient, rootUrl: string, params?: CitasControllerObtencionCitas$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CitaModelDto>>> {
  const rb = new RequestBuilder(rootUrl, citasControllerObtencionCitas.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('page', params.page, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CitaModelDto>>;
    })
  );
}

citasControllerObtencionCitas.PATH = '/api/citas/obtener-citas';
